export default __webpack_public_path__ + "static/media/Inter-UI-Italic.d6209085.woff2";